import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import Add from './add.dialog.vue'
import importDialog from './import.dialog.vue'
import CreatePNG from '@/components/createPNG.dialog.vue'
import eboard from '@/api/eboard'
import journal from '@/api/journal'
import operation from '@/api/operation'

import help from '@/utils/help'
const columnsId = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Identity',
    width: 180,
    dataIndex: 'identityCode',
    slot: 'roles'
  },
  {
    title: '',
    enTitle: 'Hierarchy',
    width: 120,
    dataIndex: 'sort'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 200,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Created Time',
    width: 150,
    dataIndex: 'createTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 180,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const columnsAll = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Country / Territory',
    width: 200,
    dataIndex: 'countryCode',
    slot: 'country'
  },
  {
    title: '',
    enTitle: 'Jounals',
    width: 200,
    dataIndex: 'journals',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 200,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Created Time',
    width: 150,
    dataIndex: 'createTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 180,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    Add,
    SiteSearchGroup,
    importDialog,
    CreatePNG
  },
  data() {
    return {
      columns: columnsId,
      isVisable: false,
      showAdv: false,
      journalList: [],
      dataSource: [],
      inputData: {},
      params: {
        released: '',
        journalId: '',
        volumeId: '',
        issueId: ''
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      isVisableImport: false,
      pdfType: 'eb-c',
      isVisablePDF: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      editorialBoard: 'getEditorialBoard',
      country: 'getCountry',
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getJournalList()
    if (this.params.journalId) {
      this.columns = columnsId
    } else {
      this.columns = columnsAll
    }
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await eboard.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet()
      if (this.journalList.length > 1) {
        this.journalList.unshift({
          name: 'All',
          journalId: '',
          id: ''
        })
      }

      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      this.getList()
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.inputData = JSON.parse(JSON.stringify(this.params))
      this.isVisable = true
    },
    // edit(val) {
    //   this.inputData = JSON.parse(JSON.stringify(this.params))
    //   this.$refs['editorial-board-add'].getQuery(val.id, {
    //     journalId: this.params.journalId
    //   })
    //   this.isVisable = true
    // },
    detail(val) {
      // this.$router.push(
      //   `/publishing/editorial-board/${val.id}/personal-information`
      // )
      help.openWindow(
        `/publishing/editorial-board/${val.id}/personal-information`
      )
    },
    async able(val) {
      const { id, released, version } = val
      await eboard.release(id, !released, {
        version,
        journalId: this.params.journalId
      })
      await operation.add({
        authorityCode: 'WEBSITE.EDITOR_BOARD.PUBLISH',
        type: 'PUBLISH',
        info: `Publish/Unpublish: ${val.email}`,
        detail: `Change from 【${released ? 'Publish' : 'Unpublish'}】 to 【${
          released ? 'Unpublish' : 'Publish'
        }】`
      })
      let content = 'This Editorial Board has been published!'
      if (released) {
        content = 'This Editorial Board has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this editorial board?',
        content:
          'Please be aware of once this editorial board is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await eboard.del(val.id, { journalId: this.params.journalId })
        await operation.add({
          authorityCode: 'WEBSITE.EDITOR_BOARD.DELETE',
          type: 'DELETE',
          info: `Delete The Editorial Board:  ${val.email}`,
          detail: `【Email】: ${val.email}<br/>
          【Name】: ${val.firstName} ${val.lastName}`
        })
        this.$message.success({
          title: 'Success',
          content: 'This Editorial Board has been deleted!'
        })
        this.getList()
      })
    },
    confirm() {
      this.getList()
      this.isVisable = false
      this.isVisableImport = false
    },
    cancel() {
      this.isVisable = false
      this.isVisableImport = false
      this.isVisablePDF = false
    },
    handleClear() {
      this.params.keyword = ''
      this.params.identityCode = ''
      this.getList()
    },
    application() {
      this.$router.push('/publishing/editorial-board/application')
    },
    changeJournal() {
      // localStorage.setItem('journalId', val)
      if (this.params.journalId) {
        this.columns = columnsId
      } else {
        this.columns = columnsAll
      }
      this.getList()
    },
    async exp() {
      this.loading = true
      try {
        const res = await eboard.export(this.params)
        await operation.add({
          authorityCode: 'WEBSITE.EDITOR_BOARD.EXPORT',
          type: 'EXPORT',
          info: `Editorial Board Data Export.`,
          detail: `Editorial Board Data Export.`
        })
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    },
    imp() {
      this.isVisableImport = true
    },
    createCanvans(val, type) {
      this.inputData = val
      this.pdfType = type
      this.isVisablePDF = true
    }
  }
}
